import * as React from "react";
const SvgRealign = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path d="M0 6.926h16v1.926H0zM8 0 4 5.778h8zM8 16l4-5.778H4z" /></svg>;
export default SvgRealign;